const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function submitLead({ name, email, phone, countryCode, message, source }) {
  const response = await fetch(`${API_URL}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      email,
      phone: phone || null,
      country_code: countryCode || null,
      message,
      source: source || "website",
    }),
  });

  if (!response.ok) throw new Error("Submission failed");
  return response.json();
}
